import { uniqueId } from 'lodash';
import { useEffect, useRef } from 'react';

import type { LiveDataStateVariables } from '@swf/sports/providers/LiveDataProvider';
import { useLiveData } from '@swf/sports/providers/LiveDataProvider';
import type { EventTypesEventIdsMap } from '@swf/sports/providers/types';

export interface LiveDataOptions {
  eventTypesEventIdsMap?: EventTypesEventIdsMap;
  playerIds?: string[];
  variables?: LiveDataStateVariables;
}

const useLiveDataPolling = ({
  eventTypesEventIdsMap,
  variables,
  playerIds
}: LiveDataOptions): void => {
  const uniqueIdRef = useRef(uniqueId());
  const { dispatch } = useLiveData();

  useEffect(() => {
    if (eventTypesEventIdsMap) {
      dispatch({
        type: 'SET_EVENTS',
        payload: {
          id: uniqueIdRef.current,
          events: eventTypesEventIdsMap,
          variables: variables ?? {
            includeIncidents: false,
            includePlayers: false,
            includeTeamStats: false
          }
        }
      });
    }

    if (playerIds?.length) {
      dispatch({
        type: 'SET_FOOTBALL_PLAYERS',
        payload: {
          players: playerIds
        }
      });
    }
  }, [dispatch, eventTypesEventIdsMap, variables, playerIds]);

  useEffect(
    () => () => {
      dispatch({
        type: 'REMOVE_EVENTS',
        payload: {
          id: uniqueIdRef.current
        }
      });
    },
    [dispatch]
  );
};

export default useLiveDataPolling;
